import PartTreeList from "../components/PartTreeList";
import {connect} from "react-redux";
import {
	createPart,
	deletePart,
	expandPart,
	loadParts, movePart,
	updatePart,
	updatePartRelationChildren
} from "../actions/partActions";
import {showSnackbar} from "../actions/snachbarActions";
import {isProcessing} from "../actions/processingActions";
import {
	PROC_PARTS_CREATE,
	PROC_PARTS_DELETE,
	PROC_PARTS_LIST,
	PROC_PARTS_UPDATE,
	PROC_PARTS_UPDATE_CHILDREN
} from "../actions";
import {isOnline} from "../actions/userActions";
// import {createPartsTree} from "../misc/tree-handler";

const m2s = (state) => ({
	parts: state.parts,
	isLoadingList: isProcessing(state, PROC_PARTS_LIST),
	isCreating: isProcessing(state, PROC_PARTS_CREATE),
	isDeleting: (part) => isProcessing(state, PROC_PARTS_DELETE, part.part_id || part),
	isChangingNumber: (parent, child) => isProcessing(state, PROC_PARTS_UPDATE_CHILDREN, `${parent}-${child}`),
	isUpdating: (part) => isProcessing(state, PROC_PARTS_UPDATE, part.part_id || part)
	// tree: (() => createPartsTree(state.parts.list, state.parts.relations))()
});
const m2d = (dispatch) => {
	dispatch(isOnline(() => {
		dispatch(loadParts());
	}));
	return {
		onCreate: (data, onSuccess) => dispatch(createPart(data, result => {
			onSuccess && onSuccess(result);
			dispatch(showSnackbar('snackbar.parts.created'));
		})),
		onLoad: (force, onSuccess) => dispatch(loadParts(force, onSuccess)),
		onDelete: (part, onSuccess) => dispatch(deletePart(part, result => {
			onSuccess && onSuccess(result);
			dispatch(showSnackbar('snackbar.parts.deleted'));
		})),
		onUpdate: (part, onSuccess) => dispatch(updatePart(part, result => {
			onSuccess && onSuccess(result);
			dispatch(showSnackbar('snackbar.parts.updated'));
		})),
		onMove: (how, onSuccess) => dispatch(movePart(how, result => {
			onSuccess && onSuccess(result);
			dispatch(showSnackbar('snackbar.parts.moved'));
		})),
		onExpand: (part, expanded) => dispatch(expandPart(part, expanded)),
		onChangeChildrenCount: (parent_id, child_id, number, onSuccess) => dispatch(updatePartRelationChildren(parent_id, child_id, number, result => {
			onSuccess && onSuccess(result);
			dispatch(showSnackbar('snackbar.parts.children-changed'))
		}))
	};
};

export default connect(m2s, m2d)(PartTreeList);


// WEBPACK FOOTER //
// ./src/containers/PartsController.js